import React from "react";
import Layout from "../components/_App/layout";
import SEO from "../components/_App/seo"; 
import Navbar from "../components/_App/Navbar";
import Team from "../components/Common/Team";
import FunFactsArea from "../components/Common/FunFactsArea";
import Partner from "../components/Common/Partner";
import Footer from "../components/_App/Footer";
import PageBanner from '../components/Common/PageBanner';

import AboutOne from "../assets/images/about-one.png";

const StartArsiv = () => (
    <Layout>
        <SEO title="Misyon & Vizyon" /> 

        <Navbar />
        <PageBanner pageTitle="Pixel Yazılım" />

        <div className="about-area ptb-80">
            <div className="container">
               

                <div className="about-inner-area">
                    <div className="row justify-content-center">
                        <div className="col-lg-5 col-md-6 col-sm-6">
                            <div className="about-text">
                                <h3>Vizyon</h3>
                                <p>Yazılım sektöründe, Türkiye’nin ve Dünya'nın bilinen markası olmak, Hizmet kalitesiyle müşterilerimizin birinci tercihi olarak sürekliliği sağlamak, kullanılabilecek en yeni teknolojiyi müşterilerimizin kullanımına sunmak ve dünya çapında etki oluşturmaktır</p>
                            </div>
                        </div>

                        <div className="col-lg-5 col-md-6 col-sm-6">
                            <div className="about-text">
                                <h3>Misyon</h3>
                                <p>Proje analiz etmek ve üretmek konusunda bilinen bir marka olmakla birlikte yazılım sektöründe işini severek yapan deneyimli ekibiyle müşterilerimize en iyi şekilde hizmet vermektir.Ayrıca çevresel duyarlılık bilinciyle malzeme israfını, iş gücü kayıplarını en aza indirmek</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row align-items-center">
                    <div className="col-lg-8 col-md-12">
                        <div className="about-image">
                            <img src={AboutOne} alt="image" />
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                        <div className="about-content">
                            <div className="section-title">
                                <h2>Hakkımızda</h2>
                                <div className="bar"></div>
                                <p>Farklı sektörlerin ihtiyaçlarına özel, güvenilir ve sürdürülebilir yazılım çözümleri geliştiren bir teknoloji firmasıyız.</p>
                            </div>

                            <p>Firmalara, ticaret odalarına, fabrikalara, eğitim kurumlarına, hastanelere, bireysel kullanıcılara ve birçok farklı faaliyet alanına yönelik proje ve çözümler sunuyoruz.</p>

                            <p>İş süreçlerinizi detaylı şekilde analiz ediyor, ihtiyaçlarınıza uygun özel yazılım projeleri tasarlıyor ve geliştiriyoruz.</p>

                            <p>Alanında uzman ekibimizle, güvenle kullanabileceğiniz yazılımlar üretirken proje sonrasında da destek ve geliştirme süreçlerinde yanınızda olmaya devam ediyoruz.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        
        <Footer />
    </Layout>
)

export default StartArsiv;
